import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";

export default function RemoveConfirmationProjectBroker(props) {
  const { open, removeItem, removeItemFuncConfirm } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  console.log("removeItem", removeItem.data.userActiveStatus)
  return (
    <>
      <Dialog
        className="user-filter-popup project-filters"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        //onClose={""}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "25px 25px", pb: "8px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">Remove Confirmation</Typography>
        </Stack>
        <Box sx={{ p: "0px 25px 0px 25px" }}>
          
        {removeItem.data.userActiveStatus ? 

        <p style={{ marginBottom: "0px"}} className="label">
        Removing this broker will move any open billing statements associated with them to orphaned billing statements. Are you sure you want to proceed?
        </p>
        :

        <p style={{ marginBottom: "0px" }} className="label">
          Are you sure you want to remove this broker mapping? 
        </p>

        }
          
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "25px" }}
        >
          <Button
            className="filter-btn"
            onClick={() => {
              removeItemFuncConfirm(removeItem);
            }}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={removeItemFuncConfirm}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
